import React, { Component } from 'react';
import classNames from 'classnames/bind';

import detectMobileOS from 'utils/detectMobileOS';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

class MarkBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOS: null,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        mobileOS: detectMobileOS(),
      });
    }, 0);
  }

  render() {
    const { mobileOS } = this.state;

    if (!mobileOS) {
      return null;
    }

    return (
      <a
        className={cx('component')}
        href="https://go.onelink.me/DMQz/site"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          className={cx('image')}
          src="//static.beeline.ru/upload/images/mlk/images/markBanner.png"
          alt=""
        />
      </a>
    );
  }
}

export default MarkBanner;
